import React from "react";
import classNames from "classnames";
import { BemHelper } from "../../utils";

type Props = {
  icon: React.ReactNode;
  label: string;
  direction?: "vertical" | "horizontal";
  onClick?: () => void;
};

const bem = new BemHelper("floating-menu-option");

export const FloatingMenuOption: React.FC<Props> = ({
  icon,
  label,
  direction = "vertical",
  onClick,
}) => {
  return (
    <div
      className={classNames(bem.block(), bem.modifier(direction))}
      onClick={() => onClick && onClick()}
    >
      {icon}
      <label className={classNames(bem.element("label"),  bem.modifier(direction,"label"))}>{label}</label>
    </div>
  );
};
